var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarCustomer10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6.45703C9.50152 6.45703 10.7188 5.23981 10.7188 3.73828C10.7188 2.23676 9.50152 1.01953 8 1.01953C6.49848 1.01953 5.28125 2.23676 5.28125 3.73828C5.28125 5.23981 6.49848 6.45703 8 6.45703Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.45704C14.4492 6.45704 15.2188 5.68753 15.2188 4.73829C15.2188 3.78904 14.4492 3.01953 13.5 3.01953C12.5508 3.01953 11.7812 3.78904 11.7812 4.73829C11.7812 5.68753 12.5508 6.45704 13.5 6.45704Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.45704C3.44924 6.45704 4.21875 5.68753 4.21875 4.73829C4.21875 3.78904 3.44924 3.01953 2.5 3.01953C1.55076 3.01953 0.78125 3.78904 0.78125 4.73829C0.78125 5.68753 1.55076 6.45704 2.5 6.45704Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19344 7.99978C3.51688 7.44546 2.90416 7.51884 2.12188 7.51884C0.951875 7.51884 0 8.46509 0 9.62791V13.0407C0 13.5457 0.412188 13.9564 0.919062 13.9564C3.10738 13.9564 2.84375 13.9959 2.84375 13.862C2.84375 11.4437 2.55731 9.67019 4.19344 7.99978Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74403 7.53101C7.37766 7.41705 6.19 7.53233 5.16559 8.37789C3.45131 9.75101 3.78122 11.5999 3.78122 13.8616C3.78122 14.46 4.26809 14.956 4.87559 14.956C11.4719 14.956 11.7344 15.1688 12.1256 14.3026C12.2539 14.0096 12.2187 14.1027 12.2187 11.3004C12.2187 9.07457 10.2914 7.53101 8.74403 7.53101Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8781 7.51876C13.0915 7.51876 12.4822 7.44614 11.8065 7.9997C13.4304 9.65769 13.1562 11.3102 13.1562 13.8619C13.1562 13.9967 12.9374 13.9562 15.0481 13.9562C15.5731 13.9562 16 13.5309 16 13.0081V9.62782C16 8.46501 15.0481 7.51876 13.8781 7.51876Z",
    fill: "#535A60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCustomer10);
export default __webpack_public_path__ + "static/media/sidebar-customer-10.efdc26de7c86b6a009fb45942214a05a.svg";
export { ForwardRef as ReactComponent };